// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2dlSY","head":"ProcedureTableInfo_head__5A56y"};